import { connect, MapStateToProps } from 'react-redux';
import { Props } from './PollOverlay';
import { getIsCurrentUserAuthorOf } from '../../../../../redux/deviations/selectors';

type StateProps = Pick<Props, 'isOwner'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, { deviation }) => {
  return { isOwner: getIsCurrentUserAuthorOf(state, deviation) };
};

export default connect(mapStateToProps);
